import { Table, Form, Input, InputNumber, Select } from "formik-antd";
import _ from "lodash";
import { Formik } from "formik";
import {
  Button,
  Space,
  Row,
  Col,
  Alert,
  message,
  Divider,
  Typography,
} from "antd";
import React, { useContext, useState } from "react";
import MultiStepFormContext from "./MultiStepFormContext";
import dayjs from "dayjs";
import axios from "axios";
import { Backdrop, CircularProgress } from "@mui/material";

const EducationRecords = () => {
  const { educationRecords, setEducationRecords, next } =
    useContext(MultiStepFormContext);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [alertMessage, setAlertMessage] = useState("Data Saved Successfully!!");

  function onFinish(values) {
    next();
  }

  const handleClose = () => {
    setAlertVisible(false);
  };

  const [loading, setLoading] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flex: 1,
        justifyContent: "center",
      }}
    >
      <Formik
        initialValues={educationRecords}
        onSubmit={(values) => {
          setLoading(true);
          setEducationRecords(values);
          var url = window.API_PREFIX + "forms/api/post/education_records";
          const requestOptions = {
            data: values,
            applicationId: sessionStorage.getItem("applicationId"),
            user: sessionStorage.getItem("username"),
            token: sessionStorage.getItem("token"),
          };
          axios
            .post(url, requestOptions)
            .then((res) => {
              if (res.data.status == 200) {
                setAlertType("success");
                setAlertMessage(res.data.info);
                setAlertVisible(true);
              } else if (res.data.status == 409) {
                setAlertType("info");
                setAlertMessage(res.data.info);
                setAlertVisible(true);
              }
              onFinish();
            })
            .catch((err) => {
              message.error(
                "Please fill the correct information. Try again after refreshing the page",
                10
              );
            })
            .finally(() => {
              setLoading(false);
            });
        }}
        validateOnChange={true}
        validateOnBlur={true}
        validate={(values) => {
          var errors = [];
          var er1 = [];
          var er = values["educationRecords"];
          for (var i = 0; i < er.length; i++) {
            let error = {};

            Object.keys(er[i]).map((key) => {
              if (
                er[i][key] === "" ||
                er[i][key] === null ||
                er[i][key] == dayjs()
              ) {
                error[key] = _.capitalize(_.startCase(key)) + " is required";
              }
              // Add duration check
              if (key === "duration" && er[i][key] <= 0) {
                error[key] = "Duration must be greater than 0";
              }
            });

            if (Object.keys(error).length == 0) {
              er1.push(null);
            } else {
              er1.push(error);
            }
          }
          errors = er1;
          if (
            errors.every((item) => {
              return item == null;
            })
          ) {
            return [];
          }
          return errors;
        }}
      >
        {({ handleSubmit, values, setFieldValue, errors, touched }) => (
          <Form>
            <Row gutter={10} style={{ margin: "10px" }}>
              <Col md={6}>
                <label>Education Assistance Required For</label>
                <Select
                  name="educationAssistanceRequiredFor"
                  style={{ width: "100%" }}
                  placeholder="Select Education Assistance Required For"
                  onChange={(e) => {
                    setFieldValue(`educationAssistanceRequiredFor`, e);
                    if (e == "12th" || e == "Diploma") {
                      setFieldValue(`educationRecords`, [
                        {
                          level: "10th",
                          institution: "",
                          location: "",
                          duration: "",
                          streamSubjects: "",
                          percentageGrade: "",
                          rollNumber: "",
                          board: "",
                          passOutYear: "",
                        },
                      ]);
                    } else if (e == "Under Graduation" || e == "Integrated") {
                      setFieldValue(`educationRecords`, [
                        {
                          level: "10th",
                          institution: "",
                          location: "",
                          duration: "",
                          streamSubjects: "",
                          percentageGrade: "",
                          rollNumber: "",
                          board: "",
                          passOutYear: "",
                        },
                        {
                          level: "12th",
                          institution: "",
                          location: "",
                          duration: "",
                          streamSubjects: "",
                          percentageGrade: "",
                          rollNumber: "",
                          board: "",
                          passOutYear: "",
                        },
                      ]);
                    } else if (e == "Post Graduation" || e == "PGDiploma") {
                      setFieldValue(`educationRecords`, [
                        {
                          level: "10th",
                          institution: "",
                          location: "",
                          duration: "",
                          streamSubjects: "",
                          percentageGrade: "",
                          rollNumber: "",
                          board: "",
                          passOutYear: "",
                        },
                        {
                          level: "12th",
                          institution: "",
                          location: "",
                          duration: "",
                          streamSubjects: "",
                          percentageGrade: "",
                          rollNumber: "",
                          board: "",
                          passOutYear: "",
                        },
                        {
                          level: "Under Graduation",
                          institution: "",
                          location: "",
                          duration: "",
                          streamSubjects: "",
                          percentageGrade: "",
                          rollNumber: "",
                          board: "",
                          passOutYear: "",
                        },
                      ]);
                    } else if (e == "Ph.D.") {
                      setFieldValue(`educationRecords`, [
                        {
                          level: "10th",
                          institution: "",
                          location: "",
                          duration: "",
                          streamSubjects: "",
                          percentageGrade: "",
                          rollNumber: "",
                          board: "",
                          passOutYear: "",
                        },
                        {
                          level: "12th",
                          institution: "",
                          location: "",
                          duration: "",
                          streamSubjects: "",
                          percentageGrade: "",
                          rollNumber: "",
                          board: "",
                          passOutYear: "",
                        },
                        {
                          level: "Graduation",
                          institution: "",
                          location: "",
                          duration: "",
                          streamSubjects: "",
                          percentageGrade: "",
                          rollNumber: "",
                          board: "",
                          passOutYear: "",
                        },
                        {
                          level: "Post Graduation",
                          institution: "",
                          location: "",
                          duration: "",
                          streamSubjects: "",
                          percentageGrade: "",
                          rollNumber: "",
                          board: "",
                          passOutYear: "",
                        },
                      ]);
                    }
                  }}
                >
                  <Select.Option value={"12th"}>12th</Select.Option>
                  <Select.Option value={"Diploma"}>Diploma</Select.Option>
                  <Select.Option value={"PGDiploma"}>PG Diploma</Select.Option>
                  <Select.Option value={"Under Graduation"}>
                    Under Graduation
                  </Select.Option>
                  <Select.Option value={"Post Graduation"}>
                    Post Graduation
                  </Select.Option>
                  <Select.Option value={"Integrated"}>Integrated</Select.Option>
                  <Select.Option value={"Ph.D."}>Ph.D.</Select.Option>
                </Select>
              </Col>
            </Row>
            <Table
              name="educationRecords"
              rowKey={(row, index) => "" + index}
              size="small"
              pagination={false}
              style={{ width: "100%", margin: "10px" }}
              columns={[
                {
                  title: "Level",
                  key: "level",
                  render: (text, record, i) => (
                    <>
                      <Input
                        // style={{ border: "none" }}
                        name={`educationRecords.${i}.level`}
                        placeholder="e.g. 10th,12th"
                        disabled
                      />
                      {errors[i] &&
                      "level" in errors[i] &&
                      touched &&
                      "educationRecords" in touched &&
                      touched["educationRecords"][i] &&
                      "level" in touched["educationRecords"][i] &&
                      touched["educationRecords"][i]["level"] ? (
                        <div style={{ color: "red" }}>{errors[i]["level"]}</div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Institution",
                  key: "institution",
                  render: (text, record, i) => (
                    <>
                      <Input
                        name={`educationRecords.${i}.institution`}
                        placeholder="Enter institute name"
                      />
                      {errors[i] &&
                      "institution" in errors[i] &&
                      touched &&
                      "educationRecords" in touched &&
                      touched["educationRecords"][i] &&
                      "institution" in touched["educationRecords"][i] &&
                      touched["educationRecords"][i]["institution"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["institution"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Location",
                  key: "location",
                  render: (text, record, i) => (
                    <>
                      <Input
                        name={`educationRecords.${i}.location`}
                        placeholder="e.g. Ahmedabad, Gujarat"
                      />
                      {errors[i] &&
                      "location" in errors[i] &&
                      touched &&
                      "educationRecords" in touched &&
                      touched["educationRecords"][i] &&
                      "location" in touched["educationRecords"][i] &&
                      touched["educationRecords"][i]["location"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["location"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Duration",
                  key: "duration",
                  render: (text, record, i) => (
                    <>
                      <Input
                        type="number"
                        name={`educationRecords.${i}.duration`}
                        placeholder="e.g. 4,3 (in years)"
                        min={0}
                      />
                      {errors[i] &&
                      "duration" in errors[i] &&
                      touched &&
                      "educationRecords" in touched &&
                      touched["educationRecords"][i] &&
                      "duration" in touched["educationRecords"][i] &&
                      touched["educationRecords"][i]["duration"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["duration"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Stream/Subjects",
                  key: "streamSubjects",
                  render: (text, record, i) => (
                    <>
                      <Input
                        // style={{ border: "none" }}
                        name={`educationRecords.${i}.streamSubjects`}
                      />
                      {errors[i] &&
                      "streamSubjects" in errors[i] &&
                      touched &&
                      "educationRecords" in touched &&
                      touched["educationRecords"][i] &&
                      "streamSubjects" in touched["educationRecords"][i] &&
                      touched["educationRecords"][i]["streamSubjects"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["streamSubjects"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Percentage",
                  key: "percentageGrade",
                  render: (text, record, i) => (
                    <>
                      <Input
                        // style={{ border: "none" }}
                        type="number"
                        min={0}
                        max={100}
                        name={`educationRecords.${i}.percentageGrade`}
                        placeholder="Enter Percentage"
                      />
                      {errors[i] &&
                      "percentageGrade" in errors[i] &&
                      touched &&
                      "educationRecords" in touched &&
                      touched["educationRecords"][i] &&
                      "percentageGrade" in touched["educationRecords"][i] &&
                      touched["educationRecords"][i]["percentageGrade"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["percentageGrade"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Enrollment Number",
                  key: "rollNumber",
                  render: (text, record, i) => (
                    <>
                      <Input
                        name={`educationRecords.${i}.rollNumber`}
                        placeholder="Enter Enrollment Number"
                      />
                      {errors[i] &&
                      "rollNumber" in errors[i] &&
                      touched &&
                      "educationRecords" in touched &&
                      touched["educationRecords"][i] &&
                      "rollNumber" in touched["educationRecords"][i] &&
                      touched["educationRecords"][i]["rollNumber"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["rollNumber"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Board",
                  key: "board",
                  render: (text, record, i) => (
                    <>
                      <Input
                        name={`educationRecords.${i}.board`}
                        placeholder="Enter board"
                      />
                      {errors[i] &&
                      "board" in errors[i] &&
                      touched &&
                      "educationRecords" in touched &&
                      touched["educationRecords"][i] &&
                      "board" in touched["educationRecords"][i] &&
                      touched["educationRecords"][i]["board"] ? (
                        <div style={{ color: "red" }}>{errors[i]["board"]}</div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Pass out year",
                  key: "passOutYear",
                  render: (text, record, i) => (
                    <>
                      <Input
                        name={`educationRecords.${i}.passOutYear`}
                        placeholder="Enter Pass out year"
                      />
                      {errors[i] &&
                      "passOutYear" in errors[i] &&
                      touched &&
                      "educationRecords" in touched &&
                      touched["educationRecords"][i] &&
                      "passOutYear" in touched["educationRecords"][i] &&
                      touched["educationRecords"][i]["passOutYear"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["passOutYear"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                // {
                //     key: "actions",
                //     render: (text, record, index) => (
                //         <RemoveRowButton
                //             style={{ border: "none" }}
                //             icon={<DeleteOutlined />}
                //             name="educationRecords"
                //             index={index}
                //         />
                //     ),
                // },
              ]}
            />

            <Row gutter={10} style={{ margin: "50px" }}>
              <Space direction="vertical" style={{ width: "100%" }}>
                {alertVisible && (
                  <Alert
                    message={alertMessage}
                    type={alertType}
                    closable
                    afterClose={handleClose}
                  />
                )}
                {alertVisible}
              </Space>
            </Row>
            <Row gutter={10} style={{ margin: "50px" }}>
              <Col>
                <Button type={"primary"} onClick={handleSubmit}>
                  Save
                </Button>
              </Col>
              {/* <Col>
                                <Button type={"success"} onClick={onFinish}>
                                    Next
                                </Button>
                            </Col> */}
            </Row>
            {/* <AddRowButton
                            name="educationRecords"
                            style={{ marginBottom: 12 }}
                            createNewRow={() => ({
                                level: '',
                                institution: '',
                                location: '',
                                duration: '',
                                streamSubjects: '',
                                percentageGrade: '',
                                rollNumber: '',
                            })}
                        >
                            Add
                        </AddRowButton> */}
          </Form>
        )}
      </Formik>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};
export default EducationRecords;
